import Loadable from "@loadable/component";

export { default as MobileAddToCart } from "./mobileAddToCart";

export const AddToCart = Loadable(
  () =>
    import(
      /* webpackChunkName: "product_add_to_cart_component" */ "./addToCart"
    )
);
